import 'bootstrap/dist/css/bootstrap.min.css';
import {useState} from "react";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {updateOrder} from "../../../redux/slices/products";
import FormOrder from "./Form.Order";

export default function UpdateOrders({show, onClose, orderData}) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)

    const handleClosing = () => onClose && onClose()

    const handleSubmit = (order) => {
        if (order.Purchaser === null) {
            toast.error('Veuilez selectionez un utilisateur')
            return
        }

        if (order.Items === null || (order.Items && order.Items.length === 0)) {
            toast.error('Veuilez selectionez au moins un produit')
            return
        }

        setIsLoading(true)

        dispatch(updateOrder({
            data: order, onResolve: () => {
                toast.success('Fait!')
                setIsLoading(false)
                handleClosing()
            }
        }))
    }

    return (
        <>
            <FormOrder
                title={'Mettre a jour une commande'}
                show={show}
                order={orderData}
                onClose={handleClosing}
                onSubmit={handleSubmit}
                isLoading={isLoading}
                confirmBtnText='Valider'
            />
        </>
    )
}
